import Cabinet from './Cabinet.vue';

export default Cabinet;



// WEBPACK FOOTER //
// ./src/pages/profile/views/cabinet/index.ts